import { FC, useState } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Image from 'next/image';
import Modal from '@/components/Modal';
import { ButtonPrimary } from '@/components/Form';
import { Body } from '@/components/Typography';
import Alert from '@/components/Alert';
import { useProfileDetail } from '@/hooks/adapters';
import { useAmplifyMutation } from '@/hooks/useAmplifyMutation';
import { performAmplifyGlobalSignout } from './deviceLimitSignout';

interface DeviceLimitPopupProps {
  isOpen: boolean;
  deviceCount: number;
}

const DeviceLimitPopup: FC<DeviceLimitPopupProps> = ({
  isOpen,
  deviceCount,
}) => {
  const [error, setError] = useState<string | null>(null);
  const { response: profileDetail } = useProfileDetail({ enabled: isOpen });

  const signOutMutation = useAmplifyMutation({
    method: 'post',
    apiName: 'v1',
    path: '/auth/sign-out',
    mutationOptions: {
      onSettled: () => {
        performAmplifyGlobalSignout();
      },
    },
  });

  const handleSignout = () => {
    setError(null);
    signOutMutation.mutate();
  };

  const otherDeviceCount = deviceCount - 1;
  const userIdentity = profileDetail?.email || profileDetail?.phone_number || '';

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      disabled={true}
      hasCloseButton={false}
      noMaxHeight={true}
      maxWidth="327px"
    >
      <Flex justifyContent="center" mb="24px">
        <Image
          src="/assets/images/device-limit/popup-illustration.png"
          alt="Device limit illustration"
          width={263}
          height={148}
        />
      </Flex>
      <Body variant="Bold16" color="shade01" mb={4}>
        Akun Kamu Aktif di {otherDeviceCount} Perangkat
      </Body>

      <Body variant="Default14" color="shade03" mb={4}>
        Akun <Body as="span" variant="Bold14" color="shade01">{userIdentity}</Body> sedang digunakan di {otherDeviceCount} perangkat.
        Silakan keluar dari semua perangkat untuk login di perangkat ini.
      </Body>

      {error && (
        <Box mb={4}>
          <Alert text={error} />
        </Box>
      )}

      <ButtonPrimary
        width="100%"
        onClick={handleSignout}
        isLoading={signOutMutation.isLoading}
        isDisabled={signOutMutation.isLoading}
        data-testid="button_globalSignout"
      >
        Keluar dari Semua Perangkat
      </ButtonPrimary>
    </Modal>
  );
};

export default DeviceLimitPopup;
